import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFamilyAllowanceChartsDataContext } from './hooks/useFamilyAllowanceChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel';

export const AverageValuePerMonth = () => {
    const { chartData } = useFamilyAllowanceChartsDataContext();

    const rawData = chartData.averageValues.monthly;

    const series = [
        {
            name: 'Valor Médio por Família',
            data: rawData.map(item => Number(item.value))
        }
    ];

    const isYearComparison =
        rawData.length > 0 &&
        rawData.every(item => item.mes === rawData[0].mes);

    const formattedSubtitles = isYearComparison
        ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`)
        : rawData.map(item => getMonthLabel(item.mes));

    return (
        <SimpleBars
            title="Valor Repassado - Mensal"
            horizontal={false}
            subtitles={formattedSubtitles}
            series={series}
        />
    );
};
